// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__327F9","overflowing":"ReadFullNote_overflowing__3WCYX"};